import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import KemRouteGuard from "@ch/pages/KemPage/components/KemRouteGuard";
import KemChatPage from "@ch/pages/KemPage/KemChatPage";
import KemConsentPage from "@ch/pages/KemPage/KemConsentPage";
import KemICPage from "@ch/pages/KemPage/KemICPage";
import KemIndexPage from "@ch/pages/KemPage/KemIndexPage";
import KemSpeechPage from "@ch/pages/KemPage/KemSpeechPage";
import KemUnavailablePage from "@ch/pages/KemPage/KemUnavailablePage";
import KemWaitingApprovalPage from "@ch/pages/KemPage/KemWaitingApprovalPage";
import NotFoundPage from "@ch/pages/NotFoundPage";

const KemRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <KemIndexPage />,
      },
      {
        path: "chat",
        element: (
          <KemRouteGuard requiredTarget="chat">
            <KemChatPage />
          </KemRouteGuard>
        ),
      },
      {
        path: "speech",
        element: (
          <KemRouteGuard requiredTarget="chat">
            <KemSpeechPage />
          </KemRouteGuard>
        ),
      },
      {
        path: "unavailable",
        element: (
          <KemRouteGuard requiredTarget="unavailable">
            <KemUnavailablePage />
          </KemRouteGuard>
        ),
      },
      {
        path: "consent",
        element: (
          <KemRouteGuard requiredTarget="consent">
            <KemConsentPage />
          </KemRouteGuard>
        ),
      },
      {
        path: "waiting-approval",
        element: (
          <KemRouteGuard requiredTarget="waiting-approval">
            <KemWaitingApprovalPage />
          </KemRouteGuard>
        ),
      },
      {
        path: "ic",
        element: (
          <KemRouteGuard requiredTarget="ic">
            <KemICPage />
          </KemRouteGuard>
        ),
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default KemRoutes;
